
'use strict';

const $ = require('jquery');

export default function itemPagination ({selector, template}) {
    if ( !selector || !template ) return;
    
    const $elem = $(selector);

    $('body').on('click', selector + ' .pagination a', function (evt) {
        const sUrl = $(this).attr('href');

        if (sUrl.indexOf('search') >= 0) {
            evt.preventDefault();

            $.ajax({
                url: sUrl,
                type: 'GET',
                data: '',
                dataType: 'json',
                success: function (response) {
                    const content = template(response);

                    $elem.html(content);
                }
            });
        }
    });
}
